
import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import UserMenu from './UserMenu';
import NotificationDropdown from './NotificationDropdown';
import OrgBadge from '@/components/brand/OrgBadge';
import GlobalSearch from './GlobalSearch';
import SubscriptionBlockedBanner from '@/components/billing/SubscriptionBlockedBanner';

const Header = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const { state } = useSidebar();
  const sidebarHidden = state === 'collapsed';

  // Hotkey CMD+K (Mac) / CTRL+K (Win) per aprire la search globale
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen(prev => !prev);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <>
      <SubscriptionBlockedBanner />
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="w-full flex h-12 items-center justify-between px-3 md:px-4">
        <div className="flex items-center gap-2">
          <Tooltip>
            <TooltipTrigger asChild>
              <SidebarTrigger
                className="h-9 w-9 border border-transparent hover:border-border hover:bg-accent"
                aria-label={sidebarHidden ? 'Mostra menu laterale' : 'Nascondi menu laterale'}
              />
            </TooltipTrigger>
            <TooltipContent side="bottom">
              {sidebarHidden ? 'Mostra menu' : 'Nascondi menu'}
            </TooltipContent>
          </Tooltip>
          <OrgBadge />
        </div>

        <div className="flex items-center space-x-3">
          {/* Search globale CMD+K */}
          <Button
            variant="outline"
            size="sm"
            onClick={() => setSearchOpen(true)}
            className="gap-2 text-muted-foreground h-8"
            aria-label="Apri ricerca globale (CMD+K)"
          >
            <Search className="h-3.5 w-3.5" />
            <span className="hidden md:inline text-xs">Cerca…</span>
            <kbd className="hidden md:inline-flex items-center px-1.5 py-0.5 rounded border bg-muted text-[10px] font-mono">
              ⌘K
            </kbd>
          </Button>
          <NotificationDropdown />
          <UserMenu />
        </div>
      </div>

      <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
    </header>
    </>
  );
};

export default Header;
